import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterInstalmentSearchValueObject extends ValueObject {
  #instalment

  constructor({instalment}) {
    super()
    this.#instalment = instalment
  }

  static create({instalment}) {
    return new FilterInstalmentSearchValueObject({
      instalment: FilterRangeSearchValueObject.create(instalment)
    })
  }

  static createWithDefaultValue({config, instalment}) {
    const {DEFAULT_INSTALMENT_SEARCH} = config.get('searchFilters')

    return new FilterInstalmentSearchValueObject({
      instalment: FilterRangeSearchValueObject.create({
        from: instalment?.from || DEFAULT_INSTALMENT_SEARCH.from,
        to: instalment?.to || DEFAULT_INSTALMENT_SEARCH.to
      })
    })
  }

  static createQueryParams({config, hasInstalment, instalment}) {
    const {
      DEFAULT_HAS_INSTALMENT_SEARCH,
      DEFAULT_FILTER_SEARCH_VALUE,
      DEFAULT_MIN_INSTALMENT_PRICE,
      DEFAULT_INSTALMENT_SEARCH,
      FILTER_NAMES,
      FILTER_QUERY_PARAMS
    } = config.get('searchFilters')

    return new FilterInstalmentSearchValueObject({
      instalment: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.INSTALMENT].from,
          value: hasInstalment ? instalment.from ?? DEFAULT_MIN_INSTALMENT_PRICE : DEFAULT_INSTALMENT_SEARCH.from
        }),
        hasInstalment: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.HAS_INSTALMENT],
          value: hasInstalment === DEFAULT_HAS_INSTALMENT_SEARCH ? DEFAULT_FILTER_SEARCH_VALUE : hasInstalment
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.INSTALMENT].to,
          value: hasInstalment ? instalment.to : DEFAULT_INSTALMENT_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#instalment.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#instalment.hasInstalment.isEmpty && {...this.#instalment.hasInstalment.queryParam}),
      ...(!this.#instalment.from.isEmpty && {...this.#instalment.from.queryParam}),
      ...(!this.#instalment.to.isEmpty && {...this.#instalment.to.queryParam})
    }
  }

  get from() {
    return this.#instalment.from
  }

  get to() {
    return this.#instalment.to
  }

  get hasInstalment() {
    return !this.isEmpty
  }

  get value() {
    return this.#instalment.value
  }

  toJSON() {
    return {instalment: this.#instalment.toJSON()}
  }
}
